import React from 'react';
import SizeArchPanel from './SizeArchPanel';
import SizeOnlyPanel from './SizeOnlyPanel';

const variants = [ SizeArchPanel, SizeOnlyPanel ];

export function SizePanel(props: any) {

  const { matching } = props;
  const panel = matching.arch_type ? 0 : 1;

  const PanelVariant = variants[panel];

  return (<PanelVariant matching={matching}></PanelVariant>);
}
